export const HERO_CONSTANTS = {
  BRIDE_GROOM_NAMES: 'Tanvi & Sanket',
  INVITATION_TEXT: 'Invite you to join them as they celebrate the start of their happily ever after.',
  ARIA_LABEL: 'Wedding Introduction',
};